<template>
  <app-modal :id="'projectSubmissionModal'" no-header>
    <h3 class="h2 mb-4">You're about to submit your loan application</h3>
    <p>
      Please ensure all of the information is accurate and you are happy with your applicaiton
      to be submitted and reviewed by our team. Once submited, you will not be able to edit the
      information and the team will be in touch following their initial review.
    </p>
    <div class="row">
      <div class="col-sm-6">
        <base-button @click="$modal.close('#projectSubmissionModal')">
          Go back
        </base-button>
      </div>
      <div class="col-sm-6 text-right">
        <base-button :loading="saving" primary @click="submit">
          Submit Application
        </base-button>
      </div>
    </div>
  </app-modal>
</template>

<script>
import { mapState } from 'vuex'

import AppModal from './AppModal.vue'

export default {
  data: () => ({
    saving: false
  }),

  name: 'ProjectSubmission',

  components: {
    AppModal
  },

  computed: {
    ...mapState({
      project: store => store.core.projects.entity
    })
  },

  methods: {
    async submit () {
      this.saving = true

      await this.$store.dispatch('core/projects/save', {
        _id: this.project._id,
        status: 'Submitted'
      })

      this.$modal.close('#projectSubmissionModal')

      this.saving = false
    }
  }
}
</script>
